import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorBattlesV2 extends InternalStaticAnchor {
	_pattern = '/my-battles';
}
